import PinjamanKaryawan from "../../../assets/img/icon/ic-pinjaman-karyawan.svg"
import PinjamanUsaha from "../../../assets/img/icon/ic-pinjaman-usaha.svg"
import Pendanaan from "../../../assets/img/icon/ic-pendanaan.svg"
import PerusahaanMitra from "../../../assets/img/icon/ic-perusahaan-mitra.svg"
function NavBottom() {
    return (
        <nav className="main-nav">
            <div className="inside-nav">
                <ul>
                    <li>
                        <a href="/pinjaman-individu">
                            <img src={PinjamanKaryawan} alt="Pinjaman Karyawan"/>
                            <span>Pinjaman Individu</span>
                        </a>
                    </li>
                    <li>
                        <a href="/pinjaman-usaha">
                            <img src={PinjamanUsaha} alt="Pinjaman Usaha"/>
                            <span>Pinjaman Usaha</span>
                        </a>
                    </li>
                    <li>
                        <a href="/pendanaan">
                            <img src={Pendanaan} alt=" Pendanaan"/>
                            <span>Pendanaan</span>
                        </a>
                    </li>
                    <li>
                        <a href="/perusahaan-mitra">
                            <img src={PerusahaanMitra} alt="Perusahaan Mitra"/>
                            <span>Perusahaan Mitra</span>
                        </a>
                    </li>
                    {/* <li style={{display:'none'}}>
                        <a href="not-available">
                            <img src={fasilitas5} alt="fasilitas5"/>
                            <span>Lainnya</span>
                        </a>
                    </li> */}
                </ul>
            </div>
           
        </nav>
        
    );
}

export default NavBottom;
